export function parseGpsValue(value?: number | string): number | undefined {
  if (!value) {
    return undefined;
  }

  return typeof value === 'number' ? value : parseFloat(value?.replace(',', '.') ?? '');
}
